module.exports = __webpack_public_path__ + "media/images/btn_login_as-4079cb3a7270a440e829dbe7452d8cc5.gif";